// extracted by mini-css-extract-plugin
export default {"hideTooltip":"c--z","fadeIn":"d--z","delay":"e--z","recommendedSizeTooltip":"f--z"};